import { createContext } from 'react';

export const QuestionValueContext = createContext(null);
